import { onInvalidApiKey } from '@/hooks/useVersionCheck';

let flagged = false;

/**
 * Drop-in fetch for supabase-js that notices the one failure a client can
 * never recover from on its own: the publishable key being rejected. Every
 * other response passes through untouched.
 */
export const instrumentedFetch: typeof fetch = async (input, init) => {
  const res = await fetch(input, init);

  if (res.status === 401 && !flagged) {
    try {
      const body = await res.clone().text();
      if (/invalid api key/i.test(body)) {
        flagged = true;
        onInvalidApiKey();
      }
    } catch {
      // body already consumed or unreadable; nothing to detect
    }
  }

  return res;
};
